import type { Transport, LogEntry, Formatter } from "../types";

export class ConsoleTransport implements Transport {
	log(entry: LogEntry, formatter: Formatter): void {
		const formatted = formatter.format(entry);
		const method = this.getConsoleMethod(entry.level);
		method(formatted);
	}

	private getConsoleMethod(level: string): (...args: unknown[]) => void {
		switch (level) {
			case "debug":
				return console.debug;
			case "info":
				return console.info;
			case "warn":
				return console.warn;
			case "error":
				return console.error;
			default:
				return console.log;
		}
	}
}

export function createConsoleTransport(): Transport {
	return new ConsoleTransport();
}
